import { Moment } from 'moment'
import { BaseModel } from "./base.model"
import { PhoneControlService } from './phone_control.service'

export class ExportResult extends BaseModel<ExportResult> {

  static DEFAULT_ATTRIBUTES = {}

  exportDate: Moment
  grade: number
  course: string
  yandexId: string
  error: string
  source: string
  sourceId: number
  sender: string
  comment: string
  origin: string
  createDate: Moment
  lastUpdate: Moment

  get isSuccess(): boolean {
    return this.yandexId != null && this.error == null
  }

  get isError(): boolean {
    return this.yandexId == null && this.error != null
  }

  get sourceLabel(): string {
    if (this.source == "Session") {
      return `Сессия (${ this.sourceId })`
    } 
    else if (this.source == "OnlineLearning::Session") {
      return `Web - Сессия (${ this.sourceId })`
    } 
    else if (this.source == "PhoneControlExportTask") {
      return `Ручная (${ this.sourceId })`
    } 
    else {
      return "Неизвестный источник"
    }
  }

  get originLabel(): string {
    return PhoneControlService.ORIGIN_LABELS[this.origin] || PhoneControlService.ORIGIN_LABELS['education']
  }

  get resultMessage(): string {
    if (this.isSuccess) {
      return `Yandex ID: ${this.yandexId}`
    } 
    else if (this.isError) {
      return `Ошибка: ${this.error}`
    }
    else {
      return 'Результат неизвестен'
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/export-result.model.ts